module.exports = __webpack_public_path__ + "img/Necklace.32fe4d9e.jpg";